
<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'TaxPayerMonitoring' }">
              <h4 class="ms-2">
                {{ label.pages.taxPayer }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="label.direction === 'rtl' ? true : false"
            :data-source="items"
            :columns="fields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            :noDataText="checkData"
            @toolbar-preparing="onToolbarPreparing($event)"
            key-expr="id"
            class="ps_Table"
            :height="dataGridHeight"
          >
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="label.pages.search"
            />
            <DxColumnChooser :enabled="true" mode="dragAndDrop" />
            <DxExport :enabled="true" />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1 company-card">
                    <p class="my-0 fs-normal"> تعداد کل شرکت ها: {{ items.length }} </p>
                  </b-col>
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-success"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.add"
                      @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                      variant="ps-secondary"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.reload"
                      @click="reloadData"
                    >
                      <b-icon
                        icon="arrow-repeat"
                        scale="1.5"
                        color="#fff"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #actions="{ data }">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                    @click="edit(data)"
                    :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="dash-square-fill"
                      scale="1.1"
                      variant="ps-edit-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    @click="changeStatus(data)"
                    :id="'changeStatusBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="dash-square-fill"
                      scale="1.1"
                      variant="ps-options-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'changeStatusBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.changeStatus }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                          @click="changeKeys(data)"
                          :id="'changeKeysBtnTlp-' + data.data.id"
                  >
                    <b-icon
                            icon="shield-lock-fill"
                            scale="1.25"
                            variant="ps-tools-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                          boundary="#app"
                          noninteractive
                          triggers="hover"
                          :target="'changeKeysBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.changeKeys }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    @click="print(data)"
                    :id="'printBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="printer-fill"
                      scale="1.1"
                      variant="ps-tools-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'printBtnTlp-' + data.data.id"
                  >
                    چاپ صورت حساب
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxSorting mode="multiple" />
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
            <DxStateStoring
              :enabled="true"
              type="localStorage"
              storage-key="adminTaxCompanyList"
            />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
      dir="rtl"
      v-model="addModal"
      header-bg-variant="ps-success"
      centered
      size="lg"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.newCompany }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="addModal = false"
          id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col lg="6" md="12" sm="12" class="mb-2">
            <label for="userId" class="ps_label pe-2">
              {{ label.form.companyManager }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="userId"
              :options="users"
              v-model="form.userId"
              :reduce="(group) => group.id"
              :clearable="false"
              size="sm"
              class="ps_select"
            >
            </v-select>
          </b-col>
          <b-col lg="6" md="12" sm="12" class="mb-2 pt-4">
            <p class="fs-smal mb-0">
              <b-icon icon="arrow-right" class="ms-1" />
              کاربری که می‌خواهید شرکت برای ایشان ثبت شود، انتخاب کنید.
            </p>
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="title" class="ps_label pe-2">
              {{ label.form.companyTitle }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="title" size="sm" v-model="form.title" />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="nationalId" class="ps_label pe-2">
              {{ label.form.nationalId }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="nationalId"
              size="sm"
              v-model="form.nationalId"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="economicCode" class="ps_label pe-2">
              {{ label.form.economicCode }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="economicCode"
              size="sm"
              v-model="form.economicCode"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="taxBranchCode" class="ps_label pe-2">
              {{ label.form.taxBranchCode }}
            </label>
            <b-form-input
              id="taxBranchCode"
              size="sm"
              v-model="form.taxBranchCode"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="taxMemoryId" class="ps_label pe-2">
              {{ label.form.taxMemoryId }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="taxMemoryId"
              size="sm"
              v-model="form.memoryTaxId"
              type="text"
              class="text-start"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="taxMemoryIdTest" class="ps_label pe-2">
              {{ label.form.taxMemoryIdTest }}
            </label>
            <b-form-input
              id="taxMemoryIdTest"
              size="sm"
              v-model="form.memoryTaxIdTest"
              type="text"
              class="text-start"
            />
          </b-col>
          <b-col lg="12" md="12" sm="12" class="my-2">
            <label for="publicKey" class="ps_label pe-2">
              {{ label.form.publicKey }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="publicKey"
              size="sm"
              v-model="form.publicKey"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="12" md="12" sm="12" class="my-2">
            <label for="privateKey" class="ps_label pe-2">
              {{ label.form.privateKey }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="privateKey"
              size="sm"
              v-model="form.privateKey"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="9" md="9" sm="12" class="my-2">
            <label for="address" class="ps_label pe-2">
              آدرس شرکت
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="address"
              size="sm"
              v-model="form.address"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12" class="my-2">
            <label for="postalCode" class="ps_label pe-2">
              کد پستی
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="postalCode"
              size="sm"
              v-model="form.postalCode"
              type="number"
              class="text-center"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="addModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addItem"
            >
              {{ label.buttons.submitInfo }}
            </b-button>
            <b-button
              v-else
              variant="ps-success"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Modal -->
    <b-modal
      dir="rtl"
      v-model="editModal"
      header-bg-variant="ps-warning"
      centered
      size="lg"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.editCompany }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="editModal = false"
          id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col lg="6" md="12" sm="12" class="mb-2">
            <label for="userId" class="ps_label pe-2">
              {{ label.form.companyManager }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="userId"
              :options="users"
              v-model="form.userId"
              :reduce="(group) => group.id"
              :clearable="false"
              size="sm"
              class="ps_select"
              disabled
            >
            </v-select>
          </b-col>
          <b-col lg="6" md="12" sm="12" class="mb-2 pt-4">
            <p class="fs-smal text-danger mb-0">
              کاربر غیرقابل ویرایش است. (در ویرایش سایر فیلدها نیز دقت کنید)
            </p>
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="title" class="ps_label pe-2">
              {{ label.form.companyTitle }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="title" size="sm" v-model="form.title" />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="nationalId" class="ps_label pe-2">
              {{ label.form.nationalId }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="nationalId"
              size="sm"
              v-model="form.nationalId"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="economicCode" class="ps_label pe-2">
              {{ label.form.economicCode }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="economicCode"
              size="sm"
              v-model="form.economicCode"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="taxBranchCode" class="ps_label pe-2">
              {{ label.form.taxBranchCode }}
            </label>
            <b-form-input
              id="taxBranchCode"
              size="sm"
              v-model="form.taxBranchCode"
              type="number"
              class="text-center"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="taxMemoryId" class="ps_label pe-2">
              {{ label.form.taxMemoryId }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="taxMemoryId"
              size="sm"
              v-model="form.memoryTaxId"
              type="text"
              class="text-start"
            />
          </b-col>
          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="taxMemoryIdTest" class="ps_label pe-2">
              {{ label.form.taxMemoryIdTest }}
            </label>
            <b-form-input
              id="taxMemoryIdTest"
              size="sm"
              v-model="form.memoryTaxIdTest"
              type="text"
              class="text-start"
            />
          </b-col>
          <b-col lg="12" md="12" sm="12" class="my-2">
            <label for="publicKey" class="ps_label pe-2">
              {{ label.form.publicKey }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="publicKey"
              size="sm"
              v-model="form.publicKey"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="12" md="12" sm="12" class="my-2">
            <label for="privateKey" class="ps_label pe-2">
              {{ label.form.privateKey }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="privateKey"
              size="sm"
              v-model="form.privateKey"
              class="text-start"
              dir="ltr"
            />
          </b-col>
          <b-col lg="9" md="9" sm="12" class="my-2">
            <label for="address" class="ps_label pe-2">
              آدرس شرکت
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="address"
              size="sm"
              v-model="form.address"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12" class="my-2">
            <label for="postalCode" class="ps_label pe-2">
              کد پستی
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="postalCode"
              size="sm"
              v-model="form.postalCode"
              type="number"
              class="text-center"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="editModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-warning"
              size="sm"
              class="mx-1"
              @click="editItem"
            >
              {{ label.buttons.saveChanges }}
            </b-button>
            <b-button
              v-else
              variant="ps-warning"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Change Public and Private Keys Modal -->
    <b-modal
      :dir="label.direction"
      v-model="keyModal"
      header-bg-variant="ps-info"
      centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.form.changeCompanyKeys }}
          « {{ itemTitle }} »
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="keyModal = false"
          id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="my-3">
          <b-col cols="12">
            <label for="publicKey" class="ps_label fw2">
              <b-icon
                      icon="key-fill"
                      scale="2"
                      class="ms-3"
                      :variant="publicFile ? 'success' : 'secondary'"
              />
              {{ label.form.publicKey }}
            </label>
            <input
                    type="file"
                    ref="publicKey"
                    id="publicKey"
                    class="fs10 me-3"
                    accept=".txt, .key"
                    v-on:change="handlePublicUpload()"
            />
          </b-col>
          <b-col cols="12" class="mt-5">
            <label for="privateKey" class="ps_label fw2">
              <b-icon
                      icon="key-fill"
                      scale="2"
                      class="ms-3"
                      :variant="privateFile ? 'success' : 'secondary'"
              />
              {{ label.form.privateKey }}
            </label>
            <input
                    type="file"
                    ref="privateKey"
                    id="privateKey"
                    class="fs10 me-3"
                    accept=".txt, .key"
                    v-on:change="handlePrivateUpload()"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="keyModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-info"
              size="sm"
              class="mx-1"
              @click="uploadKeys"
            >
              {{ label.buttons.submitAndUpload }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-primary"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";
import alert from "@/plugins/AlertMessages.js";

export default {
  name: "TaxCompanies",
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fields: [
        {
          dataField: "id",
          caption: "کد",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "title",
          caption: "عنوان شرکت",
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowSorting: false,
          allowFiltering: false,
          width: "150px",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "nationalId",
          caption: "شناسه ملی",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "createdLocal",
          caption: "تاریخ ثبت",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "companyManager",
          caption: "مسئول شرکت",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "invoiceCount",
          caption: "تعداد صورت حساب‌ها",
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "expireDateLocal",
          caption: "تاریخ انقضا",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "economicCode",
          caption: "کد اقتصادی",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "taxBranchCode",
          caption: "کد شعبه مالیاتی",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "memoryTaxId",
          caption: "شناسه حافظه مالیاتی",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "memoryTaxIdTest",
          caption: "شناسه حافظه مالیاتی آزمایشی",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "discountCode",
          caption: "کد تخفیف",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "discountIntroducer",
          caption: "معرف",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
      ],
      addModal: false,
      form: {
        userId: null,
        title: null,
        nationalId: null,
        economicCode: null,
        taxBranchCode: null,
        memoryTaxId: null,
        memoryTaxIdTest: null,
        publicKey: null,
        privateKey: null,
        address: null,
        postalCode: null,
      },
      editModal: false,
      statusModal: false,
      itemId: null,
      itemStatus: true,
      itemTitle: "",

      keyModal: false,
      publicFile: null,
      privateFile: null,
    };
  },
  computed: {
    ...mapGetters({
      postCheck: "postCheck",
      items: "operationX/taxCompanies",
      users: "operationX/websiteUserOptions",
      loadingBtn: "loadingBtn",
      printAddress: "operationX/printAddress",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.addModal = false;
        this.editModal = false;
        this.statusModal = false;
        this.keyModal = false;
        this.reloadData();
        this.reloadFields();
      }
    },
    printAddress() {
      if (this.printAddress) {
        window.open(this.printAddress, "_blank");
      }
    },
  },
  methods: {
    print(item) {
      this.$store.dispatch("operationX/printCompanyFactor", item.data.id);
    },
    add() {
      this.reloadFields();
      this.addModal = true;
    },
    addItem() {
      if (this.form.title && this.form.nationalId && this.form.economicCode) {
        this.$store.dispatch("operationX/addTaxCompany", this.form);
      } else {
        this.$store.commit("setError", alert.error.empty);
      }
    },
    changeKeys(item) {
      this.reloadFields();
      this.itemId = item.data.id;
      this.itemTitle = item.data.title;
      this.keyModal = true;
    },
    handlePublicUpload() {
      this.publicFile = this.$refs.publicKey.files[0];
      console.log(this.publicFile);
    },
    handlePrivateUpload() {
      this.privateFile = this.$refs.privateKey.files[0];
      console.log(this.privateFile);
    },
    uploadKeys() {
      if(this.publicFile || this.privateFile) {
        let formData = new FormData();
        formData.append('companyId', this.itemId);
        if (this.publicFile) {
          formData.append('publicKeyFile', this.publicFile);
        }
        if (this.privateFile) {
          formData.append('privateKeyFile', this.privateFile);
        }
        this.$store.dispatch('operationX/changeCompanyKeys', formData);
      } else {
        this.$store.commit("setError", alert.error.empty);
      }

    },
    edit(item) {
      this.itemId = item.data.id;
      this.form = {
        userId: item.data.userId,
        title: item.data.title,
        nationalId: item.data.nationalId,
        economicCode: item.data.economicCode,
        taxBranchCode: item.data.taxBranchCode,
        memoryTaxId: item.data.memoryTaxId,
        memoryTaxIdTest: item.data.memoryTaxIdTest,
        publicKey: item.data.publicKey,
        privateKey: item.data.privateKey,
        address: item.data.address,
        postalCode: item.data.postalCode,
      };
      this.editModal = true;
    },
    editItem() {
      if (this.form.title && this.form.nationalId && this.form.economicCode) {
        const payload = {
          id: this.itemId,
          value: this.form,
        };
        this.$store.dispatch("operationX/editTaxCompany", payload);
      } else {
        this.$store.commit("setError", alert.error.empty);
      }
    },
    changeStatus(item) {
      this.itemId = item.data.id;
      this.itemStatus = item.data.status;
      this.itemTitle = item.data.title;
      this.statusModal = true;
    },
    submitChange() {
      const payload = {
        id: this.itemId,
        status: this.itemStatus,
      };
      this.$store.dispatch("operationX/changeTaxCompanyStatus", payload);
    },
    reloadFields() {
      this.form = {
        userId: null,
        title: null,
        nationalId: null,
        economicCode: null,
        taxBranchCode: null,
        memoryTaxId: null,
        memoryTaxIdTest: null,
        publicKey: null,
        privateKey: null,
        address: null,
        postalCode: null,
      };
      this.publicFile = null;
      this.privateFile = null;
    },
    reloadData() {
      this.$store.dispatch("operationX/getTaxCompanies");
    },
  },
  mounted() {
    this.$store.dispatch("operationX/getWebsiteUsers");
    this.reloadData();
  },
};
</script>
